export * from './components/SignaturePad';
export { default } from './components/SignaturePad';
